import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../../Color.js";
var o = {
  main: new e([255, 127, 0]),
  selected: new e([255, 255, 255]),
  outline: new e([0, 0, 0, .5]),
  selectedOutline: new e([255, 255, 255]),
  hoverOutline: new e([255, 255, 255]),
  secondary: new e([255, 255, 255]),
  secondaryOutline: new e([100, 100, 100]),
  transparent: new e([0, 0, 0, 0])
};

function t(e, o) {
  if (o) for (var _t in o) {
    e[_t] = o[_t];
  }
}

var s = function s(e) {
  _classCallCheck(this, s);

  this.size = 8, this.hoverSize = 10, this.color = o.main, this.hoverColor = o.main, this.outlineColor = o.outline, this.hoverOutlineColor = o.hoverOutline, t(this, e);
};

var n = function n(e) {
  _classCallCheck(this, n);

  this.color = o.secondary, this.hoverColor = o.main, t(this, e);
};

var r = function r(e) {
  _classCallCheck(this, r);

  this.color = o.transparent, this.hoverColor = o.transparent, this.outlineColor = o.main, this.hoverOutlineColor = o.main, this.stagedColor = o.transparent, this.stagedOutlineColor = o.secondary, t(this, e);
};

var i = function i(e) {
  _classCallCheck(this, i);

  this.vertex = new s(), this.midpoint = new s({
    color: o.secondary,
    outlineColor: o.secondaryOutline,
    size: 6
  }), this.selected = new s({
    color: o.selected,
    hoverColor: o.selected,
    hoverOutlineColor: o.hoverOutline
  }), t(this, e);
};

var l = function l(e) {
  _classCallCheck(this, l);

  this.center = new s({
    color: o.secondaryOutline
  }), this.fill = new r(), this.line = new n(), this.vertex = new s({
    color: o.selected,
    outlineColor: o.main,
    hoverColor: o.selected,
    hoverOutlineColor: o.secondaryOutline
  }), t(this, e);
};

var c = function c(e) {
  _classCallCheck(this, c);

  this.reshapeGraphics = new i(), this.transformGraphics = new l(), t(this, e);
};

var h = new c();
export { o as colors, h as settings };